import Breadcrumbs from "components/Common/Breadcrumb"
import React, { useEffect, useMemo, useRef, useState } from "react"
import { withTranslation } from "react-i18next"
import { Col, Container, Row } from "reactstrap"
import { FaChevronLeft, FaChevronRight, FaRegEdit } from "react-icons/fa"
import { MdAdd, MdDelete, MdDownload, MdEdit, MdUpload } from "react-icons/md"
import ConfigUrl, { axiosbaseurl } from "../../config"
import { useNavigate } from "react-router-dom"
import Swal from "sweetalert2"
import { Modal, notification } from "antd"
import { SiTicktick } from "react-icons/si"
import SampleFile from "../../assets/images/Portfolio.xlsx"
import { usePermissionData } from "AppContext"
import PermittedComponent from "PermittedComponent"
import moment from "moment"
import { IoMdWarning } from "react-icons/io"
import Loader from "pages/Loader"
import * as XLSX from "xlsx"
import { RiArrowUpDownFill } from "react-icons/ri"

const Portfolio = () => {
  document.title = "Portfolio | Return First Investments"

  const [portfolios, setportfolios] = useState()
  const fileInputRef = useRef(null)

  const handleSampleDownload = () => {
    const sampleFileUrl = SampleFile // File stored in public/files
    const link = document.createElement("a")
    link.href = sampleFileUrl
    link.download = "Sample_Portfolio.xlsx" // Sets the download filename
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
  }

  const handleUpload = async () => {
    if (!portfolios) {
      notification.open({
        message: (
          <div className="d-flex">
            <div className="pr-10">
              <IoMdWarning className="text-danger" size={22} />
            </div>
            <div>Please select a file to upload</div>
          </div>
        ),
      })

      return
    }
    if (
      portfolios.type !==
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" &&
      portfolios.type !== "application/vnd.ms-excel"
    ) {
      notification.open({
        message: (
          <div className="d-flex">
            <div className="pr-10">
              <IoMdWarning className="text-danger" size={22} />
            </div>
            <div>Only .xls & .xlsx files are allowed.</div>
          </div>
        ),
      })

      return
    }

    setModal(false)

    try {
      setLoading(true)

      const formData = new FormData()
      formData.append("portfolios", portfolios)

      handleBulkExport()
      const response = await axiosbaseurl.post(
        `portfolio/upload/portfolio`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      )

      if (response?.data?.success) {
        setLoading(false)
        setportfolios()
        fileInputRef.current.value = ""
        notification.open({
          message: (
            <div className="d-flex align-items-center">
              <div className="pr-20">
                <SiTicktick className="text-success fs-4 me-2" />
              </div>
              <div className="succes-message">{response?.data?.message}</div>
            </div>
          ),
          placement: "topRight",
        })
      } else {
        setLoading(false)
        setportfolios()
        fileInputRef.current.value = ""
        notification.open({
          message: (
            <div className="d-flex">
              <div className="pr-10">
                <IoMdWarning className="text-danger" size={22} />
              </div>
              <div>Opps! Something went wrong.</div>
            </div>
          ),
        })
      }
    } catch (e) {
      setLoading(false)
      setportfolios()
      fileInputRef.current.value = ""
      notification.open({
        message: (
          <div className="d-flex">
            <div className="pr-10">
              <IoMdWarning className="text-danger" size={22} />
            </div>
            <div>Opps! Something went wrong.</div>
          </div>
        ),
        description: e?.response?.data?.message,
      })
    }
  }

  const [AddModal, setModal] = useState(false)

  const { checkAccess } = usePermissionData()

  const Navigate = useNavigate()

  const [tipsData, settipsData] = useState([])
  const [Data, setData] = useState([])

  const [Loading, setLoading] = useState(false)

  useEffect(() => {
    getData()
  }, [])

  async function getData() {
    setLoading(true)
    try {
      const response = await axiosbaseurl.get(`portfolio`)
      if (response?.data?.success) {
        settipsData(response?.data?.data?.reverse())
        setData(response?.data?.data?.reverse())
      }
    } catch (e) {
      console.log("Error", e.response.data.message)
    } finally {
      setLoading(false)
    }
  }

  const filterByName = e => {
    const filteredData = tipsData?.filter(
      session =>
        session.customer?.customerName
          .toLowerCase()
          .includes(e.target.value.toLowerCase()) ||
        session.portfolioValue
          .toLowerCase()
          .includes(e.target.value.toLowerCase()) ||
        session.portfolioCurrentValue	
          .toLowerCase()
          .includes(e.target.value.toLowerCase())
    )

    setData(filteredData)
  }

  const handleDelete = ID => {
    Swal.fire({
      title: "Are you sure?",
      text: "You want to delete this Portfolio",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, Delete",
      cancelButtonText: "Cancel",
    }).then(async result => {
      if (result.isConfirmed) {
        try {
          const response = await axiosbaseurl.delete(`/portfolio/${ID}`) // Use correct API endpoint

          if (response?.data?.success) {
            notification.open({
              message: (
                <div className="d-flex align-items-center">
                  <div className="pr-20">
                    <SiTicktick className="text-success fs-4 me-2" />
                  </div>
                  <div className="succes-message">
                    Portfolio Deleted Successfully.
                  </div>
                </div>
              ),
              placement: "topRight",
            })

            // Refresh user list after delete
            getData()
          }
        } catch (error) {
          notification.open({
            message: (
              <div className="d-flex">
                <div className="pr-10">
                  <IoMdWarning className="text-danger" size={22} />
                </div>
                <div>Opps! Something went wrong.</div>
              </div>
            ),
            description: error?.response?.data?.message,
          })
        }
      }
    })
  }

  const [page, setPage] = useState(1)

  useEffect(() => window.scrollTo(0, 0), [])

  const [items_perpage, setItemsPerPage] = useState(10)

  const total_pages = Math.ceil(tipsData?.length / items_perpage)

  const changePage = pagecount => {
    if (pagecount > 0 && pagecount <= total_pages) {
      setPage(pagecount)
      window.scrollTo(0, 0)
    }
  }

  const handleExportPortfolio = item => {
    if (!item?.stockDetails) return

    const parsedStockDetails = JSON.parse(item.stockDetails)

    const stockRows = parsedStockDetails.map(stock => ({
      Symbol: stock.Symbol,
      Name: stock.Name,
      ISIN: stock.ISIN,
      "Purchase Date": stock.PurchaseDate,
      "Purchase Qty": stock.PurchaseQty,
      "Purchase Amount": stock.PurchaseAmount,
      "Sell Date": stock.SellDate,
      "Sell Qty": stock.SellQty,
      "Sell Amount": stock.SellAmount,
      "Investment Qty": stock.InvestmentQty,
      "Investment Cost": stock.InvestmentCost,
      "Investment Amount": stock.InvestmentAmount,
      "Market Price": stock.MarketPrice,
      Notional: stock.Notional,
    }))

    // Create a new worksheet manually
    const ws = XLSX.utils.aoa_to_sheet([
      ["Client ID:", item?.customer?.id || "--"],
      ["Client Name:", item?.customer?.customerName || "--"],
      ["Portfolio Value:", item?.portfolioValue],
      [], // Empty row
    ])

    // Add stock data with headers starting at row 4 (i.e. index 3)
    XLSX.utils.sheet_add_json(ws, stockRows, {
      origin: "A5",
      skipHeader: false,
    })

    const wb = XLSX.utils.book_new()
    XLSX.utils.book_append_sheet(wb, ws, "Portfolio")

    XLSX.writeFile(
      wb,
      `Portfolio_${item?.customer?.customerName}_${item.id}.xlsx`
    )
  }

  const handleBulkExport = () => {
    const allRows = []

    Data?.forEach(item => {
      const parsedStockDetails = JSON.parse(item.stockDetails)

      parsedStockDetails.forEach(stock => {
        allRows.push({
          customerId: item?.customer?.id || "--",
          customerName: item?.customer?.customerName || "--",
          stockName: stock.Symbol,
          stockqty: stock.PurchaseQty,
          stockbuyPrice: stock.PurchaseAmount,
          stocksellPrice: stock.SellAmount || "N/A",
          sector: stock.sector,
        })
      })
    })

    const ws = XLSX.utils.json_to_sheet(allRows)
    const wb = XLSX.utils.book_new()
    XLSX.utils.book_append_sheet(wb, ws, "All Portfolios")

    XLSX.writeFile(wb, `All_Portfolios.xlsx`)
  }

  const [sortConfig, setSortConfig] = useState({
    key: null,
    direction: "ascending",
  })

  // Sorting logic
  const sortedData = useMemo(() => {
    if (!sortConfig.key) return Data

    const sortableItems = [...Data]
    sortableItems.sort((a, b) => {
      let aValue, bValue

      switch (sortConfig.key) {
        case "customerName":
          aValue = (a.customer?.customerName || "").toLowerCase()
          bValue = (b.customer?.customerName || "").toLowerCase()
          break
        case "portfolioValue":
          aValue =
            parseFloat(
              String(a.portfolioValue || "0").replace(/[^0-9.-]+/g, "")
            ) || 0
          bValue =
            parseFloat(
              String(b.portfolioValue || "0").replace(/[^0-9.-]+/g, "")
            ) || 0
          break
        case "portfolioCurrentValue":
          aValue =
            parseFloat(
              String(a.portfolioCurrentValue || "0").replace(/[^0-9.-]+/g, "")
            ) || 0
          bValue =
            parseFloat(
              String(b.portfolioCurrentValue || "0").replace(/[^0-9.-]+/g, "")
            ) || 0
          break
        case "createdAt":
          aValue = new Date(a.createdAt)
          bValue = new Date(b.createdAt)
          break
        default:
          aValue = a[sortConfig.key]
          bValue = b[sortConfig.key]
      }

      if (aValue < bValue) return sortConfig.direction === "ascending" ? -1 : 1
      if (aValue > bValue) return sortConfig.direction === "ascending" ? 1 : -1
      return 0
    })

    return sortableItems
  }, [Data, sortConfig])

  const final_data = sortedData.slice(
    (page - 1) * items_perpage,
    page * items_perpage
  )

  const requestSort = key => {
    let direction = "ascending"
    if (sortConfig.key === key && sortConfig.direction === "ascending") {
      direction = "descending"
    }
    setSortConfig({ key, direction })
  }

  // Arrow indicator helper
  const getSortArrow = key => {
    if (sortConfig.key === key) {
      return sortConfig.direction === "ascending" ? "▲" : "▼"
    }
    return <RiArrowUpDownFill size={18} />
  }

  return (
    <React.Fragment>
      {Loading && <Loader />}
      <PermittedComponent isAccess={checkAccess(1, 1)}>
        <div className="page-content">
          <Container fluid>
            {/* Render Breadcrumb */}
            <Breadcrumbs title={""} breadcrumbItem={"Portfolio"} />

            <div className="card p-2 py-3">
              <div className="d-flex flex-column flex-xl-row justify-content-between">
                <div className="search-box position-relative">
                  <input
                    className="form-control ps-6"
                    placeholder="Search Portfolio"
                    onChange={filterByName}
                  />
                  <i className="bx bx-search-alt search-icon"></i>
                </div>

                <div className="mt-3 mt-xl-0">
                  {checkAccess(1, 2) && (
                    <button
                      className="btn Add-Button rounded-5 mt-3 mt-xl-0"
                      onClick={() =>
                        Navigate(`${ConfigUrl.appurl}add-portfolio`)
                      }
                    >
                      <MdAdd /> Add Portfolio
                    </button>
                  )}
                </div>
              </div>

              <div className="table-responsive mt-4">
                <table className="mb-0 table Custom-Table">
                  <thead>
                    <tr>
                      <th>Sr No.</th>
                      <th
                        style={{ cursor: "pointer" }}
                        onClick={() => requestSort("customerName")}
                      >
                        Customer Name {getSortArrow("customerName")}
                      </th>
                      <th
                        style={{ cursor: "pointer" }}
                        onClick={() => requestSort("portfolioValue")}
                      >
                        Invested Value {getSortArrow("portfolioValue")}
                      </th>
                      <th
                        style={{ cursor: "pointer" }}
                        onClick={() => requestSort("portfolioCurrentValue")}
                      >
                        Current Value {getSortArrow("portfolioCurrentValue")}
                      </th>
                      <th
                        style={{ cursor: "pointer" }}
                        onClick={() => requestSort("createdAt")}
                      >
                        Created At {getSortArrow("createdAt")}
                      </th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {final_data?.map((item, index) => (
                      <tr key={item?.id}>
                        <td>{(page - 1) * items_perpage + index + 1}</td>
                        <td>{item?.customer?.customerName}</td>
                        <td>
                          {item?.portfolioValue
                            ? `₹ ${parseFloat(
                                String(item.portfolioValue).replace(
                                  /[^0-9.-]+/g,
                                  ""
                                )
                              ).toLocaleString("en-IN")}`
                            : "--"}
                        </td>
                        <td>
                          {item?.portfolioCurrentValue
                            ? `₹ ${parseFloat(
                                String(item.portfolioCurrentValue).replace(
                                  /[^0-9.-]+/g,
                                  ""
                                )
                              ).toLocaleString("en-IN")}`
                            : "--"}
                        </td>
                        <td>
                          {moment(item?.createdAt).format(
                            "DD MMMM YYYY | HH:mm A"
                          )}
                        </td>
                        <td className="d-flex justify-content-center">
                          {checkAccess(1, 3) && (
                            <>
                              <button
                                className="btn Edit-Button me-2 rounded-5"
                                onClick={() =>
                                  Navigate(
                                    `${ConfigUrl.appurl}edit-portfolio/${item?.id}`
                                  )
                                }
                              >
                                <MdEdit /> Edit
                              </button>
                              <button
                                className="btn export-Button me-2 rounded-5"
                                onClick={() => handleExportPortfolio(item)}
                              >
                                <MdDownload /> Export
                              </button>
                            </>
                          )}
                          {checkAccess(1, 4) && (
                            <button
                              className="btn delete-Button rounded-5"
                              onClick={() => handleDelete(item?.id)}
                            >
                              <MdDelete /> Delete
                            </button>
                          )}
                        </td>
                      </tr>
                    ))}

                    {final_data.length == 0 && (
                      <tr>
                        <td colSpan={6} className="rounded-3">
                          No Portfolios Found
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
              <div className="d-flex align-items-center justify-content-between my-4 px-2">
                <p className="mb-0 fs-7">
                  Showing {final_data?.length} out of {Data?.length} portfolios.
                </p>
                <div className="d-flex justify-content-md-start justify-content-center flex-wrap">
                  <div
                    className={`bd-number-pagination cursor-pointer rounded-2 me-2 fs-5`}
                    onClick={() => changePage(page - 1)}
                    style={{ cursor: "pointer" }}
                  >
                    <FaChevronLeft />
                  </div>
                  {(() => {
                    const maxVisiblePages = 5
                    const startPage = Math.max(
                      1,
                      page - Math.floor(maxVisiblePages / 2)
                    )
                    const endPage = Math.min(
                      total_pages,
                      startPage + maxVisiblePages - 1
                    )
                    const visiblePages = []

                    for (let i = startPage; i <= endPage; i++) {
                      visiblePages.push(i)
                    }

                    return visiblePages.map(pagecount => (
                      <div
                        key={pagecount}
                        className={`bd-number-pagination cursor-pointer rounded-2 me-1 fs-5 ${
                          page === pagecount ? "activepage" : ""
                        }`}
                        style={{ cursor: "pointer" }}
                        onClick={() => changePage(pagecount)}
                      >
                        {pagecount < 10 ? "0" + pagecount : pagecount}
                      </div>
                    ))
                  })()}
                  <div
                    className={`bd-number-pagination cursor-pointer rounded-2 ms-2 fs-5`}
                    onClick={() => changePage(page + 1)}
                    style={{ cursor: "pointer" }}
                  >
                    <FaChevronRight />
                  </div>
                </div>
              </div>
            </div>
          </Container>
        </div>
        <Modal
          open={AddModal}
          onCancel={() => setModal(false)}
          title="Import Portfolios"
          footer={false}
          width={700}
          style={{ top: 100 }}
        >
          <div className="Modal-Body mt-4">
            <div className="Card">
              <h5 className="fw-bold mb-0">Step by Step Import Guidance </h5>
              <div className="Instruction">
                <div className="Instruction-main">
                  <ol>
                    <li>
                      Download the sample file and fill it with proper data.
                    </li>
                    <li>
                      You can download the example file to understand how the
                      data must be filled.
                    </li>
                    <li>
                      Once you have downloaded and filled the sample file,
                      upload it in the form below and submit.
                    </li>
                  </ol>
                </div>
              </div>
            </div>
            <div className="Card mt-2">
              <h5 className="fw-bold mb-0">Bulk Portfolio Upload</h5>
              <div className="Instruction">
                <div className="form-group">
                  <label className="fw-bold fs-6">
                    Upload File <span className="text-danger">*</span>
                  </label>
                  <input
                    type="file"
                    accept=".xlsx , .xls"
                    required
                    ref={fileInputRef}
                    className="form-control"
                    onChange={e => {
                      setportfolios(e.target.files[0])
                    }}
                  />
                </div>
                <div className="w-100 d-flex justify-content-between">
                  <div
                    className="btn delete-Button mt-3 fs-6 w-50 d-flex justify-content-center align-items-center"
                    onClick={() => handleSampleDownload()}
                  >
                    <MdDownload className="me-2 fs-4" /> Download Sample File
                  </div>
                  <div
                    className="btn export-Button mt-3 fs-6 ms-3 w-50 d-flex justify-content-center align-items-center"
                    onClick={() => handleUpload()}
                  >
                    <MdUpload className="me-2 fs-4" /> Upload
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Modal>
      </PermittedComponent>
    </React.Fragment>
  )
}

export default Portfolio
